enum CueSize {
    XS,
    S,
    M,
    L,
    XL
}

export default CueSize;